import React from 'react';
import { TextBadgeLayoutProps, TextBadgeVariant } from '../types';

import styles from './TextBadgeLayout.module.scss';

export default function TextBadgeLayoutWeb(props: TextBadgeLayoutProps) {
  const { text, variant = TextBadgeVariant.PRIMARY } = props;

  const classes = [
    styles.badge,
    styles[variant],
    props.isSmall ? styles.small : styles.large
  ]

  return (
    <span className={classes.join(' ')} title={props.title}>
      {text}
    </span>
  );
}
